import React from "react";
import styled from "styled-components";
import Subtitle from "../../components/shared/text/Subtitle";
import { smMedia } from "../../utils/getMediaStyle";

const Container = styled.div`
  display: flex;
  height: 422px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.background.contentBreaker};
  padding: 102px 0;
  ${smMedia`
    width: 100vw;
    overflow:hidden;
    padding: 64px 0;
    height: auto;
  `}
`;
const LogoList = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
`;
const Logo = styled.img`
  margin-left: 40px;
  margin-right: 40px;
  ${smMedia`
    margin: 12px 24px;
    width: 73px;

  `}
`;

const BrandList = (props) => {
  return (
    <Container className="d-flex flex-column" {...props}>
      <Subtitle
        size={24}
        smSize={18}
        className="pl-5 mr-2 ml-2 pr-5 text-center"
      >
        Copysmith is trusted by 100+ stores
      </Subtitle>
      <LogoList className="d-flex mt-4 mt-md-5">
        <Logo src="http://placehold.jp/187x113.png" alt="Brand" />
        <Logo src="http://placehold.jp/187x113.png" alt="Brand" />
        <Logo src="http://placehold.jp/187x113.png" alt="Brand" />
        <Logo src="http://placehold.jp/187x113.png" alt="Brand" />
        <Logo src="http://placehold.jp/187x113.png" alt="Brand" />
      </LogoList>
    </Container>
  );
};

export default BrandList;
